import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Subject } from 'rxjs';

@Component({
  selector: 'lum-ui-expand-all-ag-grid',
  templateUrl: './ui-expand-all-ag-grid.component.html',
  styleUrls: ['./ui-expand-all-ag-grid.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class UiExpandAllAgGridComponent implements OnDestroy, IHeaderAngularComp {
  params :IHeaderParams;
  isExpanded = false;

  #destroy$ = new Subject<void>();

  constructor(private cd :ChangeDetectorRef) {}

  ngOnDestroy() :void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  agInit(params :IHeaderParams) :void {
    this.params = params;
  }

  onExpandAllClick() :void {
    this.isExpanded = !this.isExpanded;

    // NOTE: `api.expandAll()` only works for row groups, NOT for master/detail
    // rows.  This code should work for both.  Also, rather than calling
    // `setExpanded` or `setRowNodeExpanded`, which would fire a ton of
    // expand/collapse events, we do it manually, then trigger the event
    // manually after all of them have been set properly. [calvin]
    this.params.api.forEachNode((node) => {
      if (node.isExpandable()) {
        node.expanded = this.isExpanded;
      }
    });
    this.params.api.onGroupExpandedOrCollapsed();
  }

  refresh(params :IHeaderParams) :boolean {
    return false;
  }
}
